export default [
  {
    path: '/device/:id/reports',
    name: 'device-reports',
    component: () => import('@/views/reports/Reports.vue'),
  },
]
